const ChallengeComplete = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={166}
    height={166}
    viewBox='0 0 166 166'
  >
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#FFF'
        d='M165 83c0 45.287-36.895 82-82.182 82C37.53 165 1 128.287 1 83S37.53 1 82.818 1C128.105 1 165 37.713 165 83'
      />
      <path
        stroke='#E3E6E8'
        strokeWidth={2}
        d='M165 83c0 45.287-36.895 82-82.182 82C37.53 165 1 128.287 1 83S37.53 1 82.818 1C128.105 1 165 37.713 165 83z'
      />
      <path
        fill='#EA4F5C'
        d='M145.72 98.234L111.02 84.985l11.69-30.619 34.701 13.249z'
      />
      <path
        fill='#FFF'
        d='M66.714 138.235l-1.016-.388a2.733 2.733 0 0 1-1.58-3.529l37.017-96.957a2.733 2.733 0 0 1 3.529-1.578l1.016.388a2.733 2.733 0 0 1 1.579 3.528l-37.016 96.957a2.733 2.733 0 0 1-3.529 1.579'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M145.72 98.234L111.02 84.985l11.69-30.619 34.701 13.249z'
      />
      <path
        stroke='#424547'
        strokeWidth={2}
        d='M66.714 138.235l-1.016-.388a2.733 2.733 0 0 1-1.58-3.529l37.017-96.957a2.733 2.733 0 0 1 3.529-1.578l1.016.388a2.733 2.733 0 0 1 1.579 3.528l-37.016 96.957a2.733 2.733 0 0 1-3.529 1.579z'
      />
      <path
        fill='#f9e8eb'
        d='M125.122 78.675L90.42 65.427l11.69-30.62 34.702 13.25z'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M98.882 61.641l7.014-18.371'
      />
      <path fill='#C12335' d='M125.122 78.675l-14.103 6.31 3.897-10.206z' />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M125.122 78.675l-14.103 6.31 3.897-10.206zM125.122 78.675L90.42 65.427l11.69-30.62 34.702 13.25z'
      />
      <path
        fill='#FFF'
        d='M97.525 139.054l1.026-.363a2.734 2.734 0 0 0 1.664-3.489L65.591 37.366A2.733 2.733 0 0 0 62.1 35.7l-1.025.363a2.733 2.733 0 0 0-1.665 3.489l34.625 97.836a2.733 2.733 0 0 0 3.489 1.665'
      />
      <path
        stroke='#424547'
        strokeWidth={2}
        d='M97.525 139.054l1.026-.363a2.734 2.734 0 0 0 1.664-3.489L65.591 37.366A2.733 2.733 0 0 0 62.1 35.7l-1.025.363a2.733 2.733 0 0 0-1.665 3.489l34.625 97.836a2.733 2.733 0 0 0 3.489 1.665z'
      />
      <path
        fill='#7C53A5'
        d='M19.524 97.125l35.017-12.392-10.935-30.897L8.589 66.228z'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M19.524 97.125l35.017-12.392-10.935-30.897L8.589 66.228z'
      />
      <path
        fill='#7C53A5'
        d='M40.597 78.078l35.016-12.392L64.68 34.789 29.662 47.181z'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M67.247 61.693l-6.56-18.538'
      />
      <path fill='#4B286D' d='M40.597 78.078l13.944 6.655-3.645-10.3z' />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M40.597 78.078l35.016-12.392L64.68 34.789 29.662 47.181z'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M40.597 78.078l13.944 6.655-3.645-10.3z'
      />
    </g>
  </svg>
);

export default ChallengeComplete;
